export default __webpack_public_path__ + "static/media/sign-in.a96292c3.png";